import { useEffect, useRef } from "react";
import { BusinessStatusColor, DASHBOARD_COLORS, generateColorWithShades } from "../../../../helper/constant";

const Common360Table = ({ title, sections, suppliers = [], styles = {} }) => {
    const tableRef = useRef(null);

    useEffect(() => {
        if (tableRef.current === null) return;
        const table = tableRef.current;
        const thEls = table.querySelectorAll("th");

        thEls.forEach((th) => {
            const resizer = document.createElement("div");
            resizer.classList.add("resizer");
            th.appendChild(resizer);

            let startX, startWidth;

            resizer.addEventListener("mousedown", (e) => {
                startX = e.clientX;
                startWidth = th.offsetWidth;

                const handleMouseMove = (e) => {
                    const newWidth = startWidth + (e.clientX - startX);
                    th.style.width = `${newWidth}px`;
                };

                const handleMouseUp = () => {
                    document.removeEventListener("mousemove", handleMouseMove);
                    document.removeEventListener("mouseup", handleMouseUp);
                };

                document.addEventListener("mousemove", handleMouseMove);
                document.addEventListener("mouseup", handleMouseUp);
            });
        });
    }, [tableRef.current]);

    const renderTableHeader = () => {
        return (
            <thead>
                {/*  Main header 1 */}
                <tr className="main-header">
                    <th style={styles} colSpan={suppliers.length + 2}>{title}</th>
                </tr>

                {/* Small headers */}
                <tr className="small-header">
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Section</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Category / Attribute</th>
                    {suppliers.map((supplier, index) => {
                        return (
                            <th key={`supplier-col-${index}`} style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>{supplier.name || supplier['Company Name']}</th>)
                    })}
                </tr>
            </thead>
        );
    }

    const renderTableBody = () => {
        if (suppliers.length) {
            return (
                <tbody>
                    {Object.entries(sections).map(([sectionName, attributes]) =>
                        attributes.map((attribute, idx) => {
                            return (
                                <tr key={`${sectionName}-${attribute}`}>
                                    {idx === 0 && (
                                        <td rowSpan={attributes.length} style={{ verticalAlign: "middle", fontWeight: "bold", backgroundColor: BusinessStatusColor.DEFAULT }}>
                                            <span>{sectionName}</span>
                                        </td>
                                    )}
                                    <td style={{}} className="text-left">{attribute}</td>
                                    {suppliers.map((supplier, j) => (
                                        <td key={j} style={{ backgroundColor: j % 2 === 0 ? BusinessStatusColor.DEFAULT : '' }} className="text-left">{supplier[attribute] || "--"}</td>
                                    ))}
                                </tr>
                            )
                        })
                    )}
                </tbody >
            );
        };
    }

    return (
        <div className='resizable-table-container'>
            <table ref={tableRef} className="resizable-table resizable-single-table mb-4">
                {renderTableHeader()}
                {renderTableBody()}
            </table>
        </div>
    );
}
export default Common360Table;